import { render } from "./Product.vue?vue&type=template&id=a7a2e0d0&ts=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=a7a2e0d0&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__